'use client';

import { forwardRef } from 'react';
import type { VisuallyHiddenProps as MantineVisuallyHiddenProps } from '@mantine/core';
import { VisuallyHidden as MantineVisuallyHidden } from '@mantine/core';

import type { LockedProps } from '../types';

export type VisuallyHiddenProps = Omit<MantineVisuallyHiddenProps, LockedProps>;

/**
 * Text for assistive tech only — present in the accessibility tree, invisible on screen. Reach for
 * it when a control's meaning is carried by something a screen reader can't read, such as a colour
 * or an icon; pair it with `aria-describedby` rather than letting it fall into the reading order on
 * its own.
 */
export const VisuallyHidden = forwardRef<HTMLSpanElement, VisuallyHiddenProps>((props, ref) => {
  return <MantineVisuallyHidden {...props} ref={ref} />;
});

VisuallyHidden.displayName = 'VisuallyHidden';
